;

(function (GC) {
  var GCOptimizely = function GCOptimizely(analytics) {
    var optimizelyHelpers = {
      getOptimizely: function getOptimizely() {
        // We currently have 2 versions of optimizely on the site, drop the 2 when classic is gone.
        return window.optimizely2 || window.optimizely || [];
      },
      getOptimizelyData: function getOptimizelyData() {
        var optimizely = this.getOptimizely();
        var state = optimizely.get('state');
        var visitor = optimizely.get('visitor');
        var experimentsObject = state.getExperimentStates({
          isActive: true
        });
        var experiments = Object.keys(experimentsObject).map(function (key) {
          return optimizelyHelpers.parseExperimentData(experimentsObject[key]);
        });
        kmVariationIntegration(experiments);
        return {
          visitorId: visitor.visitorId,
          experiments: experiments
        };
      },
      parseExperimentData: function parseExperimentData(experiment) {
        return {
          name: experiment.experimentName,
          experimentId: experiment.id,
          variation: experiment.variation.name,
          variationId: experiment.variation.id
        };
      },
      trackEvent: function trackEvent(handler) {
        var optimizely = this.getOptimizely();
        optimizely.push({
          type: 'addListener',
          filter: {
            type: 'analytics',
            name: 'trackEvent'
          },
          handler: handler
        });
      }
    };

    try {
      var user = optimizelyHelpers.getOptimizelyData();
    } catch (e) {
      var user = {
        visitorId: '',
        experiments: []
      };
    }

    return {
      optimizely: optimizelyHelpers,
      user: user
    };
  };

  var kmEventIntegration = function kmEventIntegration(event) {
    var experiments = GC.analytics.user.experiments;

    if (experiments.length > 0) {
      var experiment = experiments.map(function (experiment) {
        var km = {};
        km[experiment.name] = experiment.variation;
        return km;
      });
      window._kmq = window._kmq || [];
      var user = window.GC.analytics.user;

      window._kmq.push(['record', event.data.name].concat(experiment));

      user.events = user.events || [];
      user.events.push(event);
    }
  };

  var kmVariationIntegration = function kmVariationIntegration(experiments) {
    if (experiments.length > 0) {
      // Format the experiments into a format KissMetrics can process
      var km = {};
      experiments.forEach(function (experiment) {
        km[experiment.name] = experiment.variation;
      });
      window._kmq = window._kmq || []; // Set the experiments as properties on the current KissMetrics session

      window._kmq.push(['set', km]);
    }
  };

  GC.queue = GC.queue || [];
  GC.queue.push({
    method: function method(mount, GCmodule) {
      this._loadModule(mount, GCmodule);
    },
    args: ['analytics', new GCOptimizely()]
  });
  window.GC = GC;
})(window.GC || {});